import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs xl:text-base font-bold dark:text-white dark:text-opacity-90" }
const _hoisted_2 = { class: "flex items-center mt-4 ml-4 text-xs xl:text-base" }
const _hoisted_3 = { class: "dark:text-white dark:text-opacity-90" }
const _hoisted_4 = { class: "dark:text-white dark:text-opacity-90" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.selections[0].name), 1),
      _createVNode(_component_Slider, {
        "is-first-value": _ctx.currentSelection === _ctx.selections[0].value,
        "is-disabled": _ctx.isDisabled,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          !_ctx.isDisabled &&
            _ctx.$emit(
              'update:value',
              _ctx.currentSelection === _ctx.selections[0].value
                ? _ctx.selections[1].value
                : _ctx.selections[0].value
            )
        ))
      }, null, 8, ["is-first-value", "is-disabled"]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.selections[1].name), 1)
    ])
  ]))
}